<template>
  <div class="main-category">
    <ModalInstallChatBot ref="install"/>
    <ModalStoreUploadEdit :selectEdit="selectEdit" ref="storeup"/>
    <p class="title-box">{{title}}</p>
    <p class="subtitle-box">{{subtitle}}</p>
    <p class="blank"></p>
    <div class="bot-list">
      <div class="card-item" v-for="(s, index) in stores" :key="index" v-if="isCategory(s.category)">
        <div class="card-icon">
          <img class="img-icon" :src="s.icon" v-if="s.icon!==''"/>
          <img class="img-icon" src="@/assets/template/robot.png" v-if="s.icon===''">
          <p class="official" v-if="s.is_official">公式</p>
        </div>
        <div class="card-desc">
          <div style="position: relative;">
            <button @click="openStoreUploadEdit(s)" class="button" style="font-size: 11px; position: absolute; right: 20px;" v-if="user.isAgent">編集</button>
            <button @click="openStoreDelete(s)" class="button is-danger" style="font-size: 11px; position: absolute; right: 60px;" v-if="user.isAgent">削除</button>
            <p class="card-name">{{s.name}}</p>
            <div class="left-box">
              <p class="card-subname" style="width: 200px;" v-if="s.create_by !== ''">{{s.create_by}}</p>
              <p class="card-subname" style="width: 200px;" v-else>作成者不明</p>
            </div>
            <div class="right-box">
              <p class="card-subname"><span class="mdi mdi-file-document-box-multiple-outline" style="margin-right: 5px;"></span>{{s.scenario_list.length}}</p>
              <p class="card-subname" style="margin-left: 10px;" v-if="getInstallCount(s) > 100"><span class="mdi mdi-download-multiple" style="margin-right: 5px;"></span>{{getInstallCount(s)}}</p>
            </div>
          </div>
          <div class="rate-box">
            <star-rating style="font-size: 12px; margin-top: 0; color: #666;" :read-only="true" :increment="0.01" :rating="calcRate(s)" :star-size="15" v-if="!isInstalled(s)"></star-rating>
            <star-rating style="font-size: 12px; margin-top: 0; color: #666;" :read-only="true" :increment="0.01" :rating="calcRate(s)" :star-size="15" v-if="isInstalled(s)"></star-rating>
            <button class="btn-rate-edit" @click="isModalRate=true;selectChatBot=s" v-if="!isInstalled(s)&&!isRated(s)"><span class="mdi mdi-square-edit-outline"></span></button>
          </div>
          <button @click="install(s)" class="btn-install" v-if="isInstalled(s)"><span class="mdi mdi-download" style="margin-right: 5px;"></span>{{getPrice(s)}}</button>
          <button @click="install(s)" class="btn-installed" v-if="!isInstalled(s)"><span class="mdi mdi-checkbox-marked-circle" style="margin-right: 5px;"></span>再インストール</button>
        </div>
      </div>
    </div>
    <!-- レート画面 -->
    <b-modal width="680px" :active.sync="isModalRate">
      <div class="card modal-rate" style="border-radius: 15px;">
        <div class="card-icon" style="margin: 15px;">
          <img class="img-icon" :src="selectChatBot.icon_data" v-if="selectChatBot.icon_data"/>
          <img class="img-icon" src="@/assets/template/robot.png" v-else>
        </div>
        <p class="rate-desc" style="margin-top: 15px; font-weight: 600;">{{selectChatBot.name}}はいかがですか？</p>
        <p class="rate-desc" style="margin-bottom: 15px;">星をクリックして、評価をお願いいたします。</p>
        <star-rating v-model="ownRate" style="font-size: 12px; margin-top: 0; color: #666;" :increment="0.5" :rating="3" :star-size="30"></star-rating>
        <button @click="sendRate(selectChatBot)" class="button">評価する</button>
      </div>
    </b-modal>
    <hr>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StarRating from 'vue-star-rating'
import createUUID from '@/functions/createUUID'
import ModalStoreUploadEdit from '@/components/ui/ModalStoreUploadEdit'
import ModalInstallChatBot from '@/components/ui/ModalInstallChatBot'
export default {
  name: 'StoreView',
  componentName: 'StoreView',
  computed: {
    ...mapState('auth', ['user', 'storeCategory']),
    ...mapState('chatbot', ['stores', 'installHistory', 'rateHistory', 'chatbots'])
  },
  props: ['title', 'subtitle', 'category'],
  components: {
    ModalStoreUploadEdit,
    ModalInstallChatBot,
    StarRating
  },
  data () {
    return {
      isModalRate: false,
      selectChatBot: {
        icon: '',
        name: ''
      },
      selectEdit: null,
      ownRate: 3
    }
  },
  methods: {
    isCategory (id) {
      // 未分類の場合
      if (this.category == -1) {
        var flg = false
        for (var i in this.storeCategory) {
          if (this.storeCategory[i].category_id == id) flg = true
        }
        return !flg
      } else {
        return id == this.category 
      }
    },
    openStoreUploadEdit (bot) {
      console.debug('*** Start *** openStoreUploadEdit')
      console.debug('bot: ' + JSON.stringify(bot))
      this.$store.dispatch('chatbot/selectScenarioTable', bot)
      this.$refs.storeup.cbInfo = bot
      this.$refs.storeup.isCardModalActive = true
      console.debug('*** End *** openStoreUploadEdit')
    },
    openStoreDelete (bot) {
      this.$store.dispatch('chatbot/deleteChatBotStoreItem', { chatbotID: bot.bot_id })
    },
    install (bot) {
      console.debug('*** Start *** install')
      console.debug('bot: ' + JSON.stringify(bot))
      if (this.chatbots.length > 9 && this.user.billing === 1) {
        alert('ロボの上限に達しています。（上限：１０台）\nプランの変更をしていただくか、ロボの削除をお願いいたします。')
      } else {
        this.$store.dispatch('chatbot/selectScenarioTable', bot)
        this.$refs.install.isCardModalActive = true
      }
      console.debug('*** End *** install')
    },
    isInstalled (bot) {
      for (var i in this.installHistory) {
        if (bot.bot_id === this.installHistory[i].bot_hash && this.installHistory[i].company_hash === this.user.companyID) return false
      }
      return true
    },
    isRated (bot) {
      for (var i in this.rateHistory) {
        if (bot.bot_id === this.rateHistory[i].bot_hash && this.rateHistory[i].user_hash === this.user.userHash) return true
      }
      return false
    },
    calcRate (bot) {
      console.debug('*** Start *** calcRate')
      console.debug('bot: ' + JSON.stringify(bot))
      var result = 0
      var cnt = 0
      for (var i in this.rateHistory) {
        if (bot.bot_id === this.rateHistory[i].bot_hash) {
          result += this.rateHistory[i].rate
          cnt++
        }
      }
      console.debug('*** End *** calcRate')
      if (result === 0) return 3
      else return result / cnt
    },
    getInstallCount (bot) {
      console.debug('*** Start *** getInstallCount')
      console.debug('bot: ' + JSON.stringify(bot))
      var cnt = 0
      for (var i in this.installHistory) {
        if (bot.bot_id === this.installHistory[i].bot_hash) cnt++
      }
      console.debug('cnt: ' + cnt)
      console.debug('*** End *** getInstallCount')
      return cnt
    },
    getDetail (bot) {
      console.debug('*** Start *** getDetail')
      console.debug('bot: ' + JSON.stringify(bot))
      if (bot.detail === '') return bot.name
      else return bot.detail
    },
    sendRate (bot) {
      console.debug('*** Start *** sendRate')
      console.debug('bot: ' + JSON.stringify(bot))
      var cb = bot
      cb['rate'] = this.ownRate
      this.$store.dispatch('chatbot/createChatBotStoreRate', cb)
      this.ownRate = 3
      this.isModalRate = false
      console.debug('*** End *** sendRate')
    },
    getPrice (bot) {
      console.debug('*** Start *** getPrice')
      console.debug('bot: ' + JSON.stringify(bot))
      if (bot.price === 0) return 'Free'
      else return '¥' + bot.price
    }
  }
}
</script>

<style scoped>
.main-category {
  padding: 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  overflow-y: scroll;
}
.card-item {
  display: flex;
  justify-content: flex-start;
  width: 300px;
  height: 80px;
  margin-bottom: 50px;
  margin-right: 10px;
}
.card-name {
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 200px;
}
.rate-desc {
  font-size: 15px;
}
.title-box {
  border-bottom: solid 2px #232;
  font-size: 20px;
}
.subtitle-box {
  color: #777;
  font-size: 14px;
}
.blank {
  height: 20px;
  width: 100%;
}
.bot-list {
  display: flex;
  flex-wrap: wrap;
}
.card-subname {
  font-size: 12px;
  color: #777;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-desc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 15px;
  width: 210px;
  height: 100px;
}
.right-box {
  display: flex;
}
.official {
  font-size: 11.5px;
  margin-top: -5px;
  color: #777;
  display: flex;
  justify-content: center;
  border: solid thin #ccc;
  border-radius: 5px;
  line-height: 1.4;
}
.card-icon {
  width:  90px;
  height: 90px;
  border-radius: 10px;
}
.img-icon {
  width:  90px;
  height: 90px;
  object-fit: cover;
  border-radius: 10px;
  border: solid thin #ccc;
}
.rate-box { 
  display: flex;
  justify-content: flex-start;
  width: 150px;
}
.btn-rate-edit {
  background: rgba(0, 0, 0, 0);
  border: none;
  border: none;
  outline:none;
  cursor:pointer;
  font-size: 14px;
}
.modal-rate {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 400px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
}
.btn-install {
  font-size: 12.5px;
  font-weight: 600;
  background: rgb(14, 165, 192);
  color: white;
  border-radius: 7.5px;
  border: none;
  outline:none;
  cursor:pointer;
}
.btn-install:hover {
  background: rgb(0, 135, 162);
  border: none;
  outline:none;
  cursor:pointer;
}
.btn-installed {
  font-size: 12.5px;
  font-weight: 600;
  background: rgb(104, 125, 132);
  color: white;
  border-radius: 7.5px;
  border: none;
  outline:none;
  cursor:pointer;
}
.btn-installed:hover {
  background: rgb(120, 145, 152);
  border: none;
  outline:none;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Store/StoreView.vue